import { render, staticRenderFns } from "./ApprovalDialog.vue?vue&type=template&id=199165f0&scoped=true"
import script from "./ApprovalDialog.vue?vue&type=script&lang=js"
export * from "./ApprovalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199165f0",
  null
  
)

export default component.exports